<template>
    <div>
        <md-button @click="submitVote('up')"
        :class="{'md-raised': true, 'md-dense': true, 'md-primary': this.currentVote == 'up'}">
            <i class="fas fa-thumbs-up"></i> &nbsp; {{this.voteCounts.up + (this.currentVote == "up")}}
        </md-button>
        <md-button @click="submitVote('down')"
        :class="{'md-raised': true, 'md-dense': true, 'md-primary': this.currentVote == 'down'}">
            <i class="fas fa-thumbs-down"></i> &nbsp; {{this.voteCounts.down + (this.currentVote == "down")}}
        </md-button>
    </div>
</template>

<script>
    import APIRequests from "./APIRequests.js"
    
    export default {
        props: {
            refType: {
                type: String
            },
            refID: {
                type: String
            },
            readonly: {
                type: Boolean
            }
        },
        data: function(){
            return {
                currentVote: "",
                voteCounts: {}
            }
        },
        methods: {
            fetchVoteData: function(){
                let api_url = this.$store.state.api_url + "/api/vote/" + this.refType + "/" + this.refID + "/"
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = {}
                    if(data.myVote) this.currentVote = data.myVote.vote
                    this.voteCounts = {
                        "up": data.counts["up"] ? data.counts["up"] - (this.currentVote == "up") : 0,
                        "down": data.counts["down"] ? data.counts["down"] - (this.currentVote == "down") : 0
                    }
                })
            },
            submitVote: function(voteChoice){
                if(this.readonly) return
                if(voteChoice == this.currentVote) voteChoice = "delete"
                let api_url = this.$store.state.api_url + "/api/vote/" + this.refType + "/" + this.refID + "/vote/" + voteChoice
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then(() => {
                    this.currentVote = voteChoice
                    this.$emit("notify", "Vote updated!")
                })
            },
        },
        mounted: function(){
            this.$nextTick(function(){
                this.fetchVoteData()
            })
        }
    }
</script>
